import { useImprovementGoal } from "../../contexts/ImprovementGoal";
import { ExecutionPhaseComponent } from "./ExecutionPhaseComponent";


const ExecutionPhase = () => {
  const { goal, improvementData, recentSurveys, questions } = useImprovementGoal();

  if (!goal) {
    return null;
  }

  return (
    <ExecutionPhaseComponent questions={questions} goal={goal} improvementData={improvementData} recentSurveys={recentSurveys || []} />
  );
};

export default ExecutionPhase;
